import React from "react";
import CloseCircleIcon from "./assets/close-circle.svg";
import TargetHitSuccessIcon from "./assets/target-hit-succeed-aim.svg";
import TickCircleIcon from "./assets/tick-circle.svg";
import ColoredBox from "../ColoredBox";
import withTranslations from "../../../../../../hocs/withTranslations";
import { compose } from "redux";
import PriceAlertButton from "../PriceAlertButton/PriceAlertButton";
import useIsDesktop from "../../../../landingPage/hooks/useIsDesktop";
import classNames from "classnames";
import getAnalysisColoredBoxVariant from "./utils/getAnalysisColoredBoxVariant";
import { ANALYSIS_COLORED_BOX_VARIANTS } from "../../../../../../lib/analysisColoredBoxVariants";

const AnalysisColoredBox = ({
  translate,
  description,
  price,
  onClick,
  ariaLabel,
  variant = ANALYSIS_COLORED_BOX_VARIANTS.NECESSARY_CONDITION
}) => {
  const isDesktop = useIsDesktop();
  const coloredBoxVariant = getAnalysisColoredBoxVariant(variant);

  let img;
  const commonImageProps = {
    alt: "",
    width: 16,
    height: 16
  };

  switch (variant) {
    case ANALYSIS_COLORED_BOX_VARIANTS.NECESSARY_CONDITION:
      img = <img src={TickCircleIcon} {...commonImageProps} />;
      break;
    case ANALYSIS_COLORED_BOX_VARIANTS.TARGET_LEVEL:
      img = <img src={TargetHitSuccessIcon} {...commonImageProps} />;
      break;
    case ANALYSIS_COLORED_BOX_VARIANTS.LEVEL_OF_NEGATION:
      img = <img src={CloseCircleIcon} {...commonImageProps} />;
      break;
  }

  const descriptionWrapper = description ? (
    <p className="text-xs line-height-100 text-black-8 mb-0 overflow-hidden break-words">
      {description}
    </p>
  ) : null;

  const priceAlertWrapper = onClick ? (
    <PriceAlertButton
      onClick={onClick}
      ariaLabel={ariaLabel}
      variant={coloredBoxVariant}
    />
  ) : null;

  return (
    <ColoredBox variant={coloredBoxVariant}>
      <div className="flex items-center gap-1.5 mb-2">
        {img}
        <strong
          className={classNames(
            "font-semibold text-sm line-height-130 text-black",
            { "text-sm": isDesktop, "text-xs": !isDesktop }
          )}
        >
          {translate(`${variant}_title`)}
        </strong>
      </div>
      <div
        className={classNames("flex flex-col", {
          "gap-3": !isDesktop,
          "gap-1": isDesktop
        })}
      >
        <div
          className={classNames("flex flex-row align-center", {
            "gap-4": isDesktop,
            "gap-x-4 gap-y-1 flex-wrap": !isDesktop
          })}
        >
          {price ? (
            <strong
              className={classNames("font-bold line-height-130 text-black", {
                "text-2xl": isDesktop,
                "text-lg": !isDesktop
              })}
            >
              {price}
            </strong>
          ) : null}
          {isDesktop ? priceAlertWrapper : null}
          {!isDesktop ? descriptionWrapper : null}
        </div>
        {isDesktop ? descriptionWrapper : null}
        {!isDesktop ? priceAlertWrapper : null}
      </div>
    </ColoredBox>
  );
};

export default compose(withTranslations)(AnalysisColoredBox);
